import { Component, Input, OnInit } from '@angular/core';
import { Pagination } from '../../models/data-ingestion';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss',
})
export class DataTableComponent implements OnInit {
  @Input() headers: any[] = [];
  @Input() rows: any[] = [];
  readonly pagination: Pagination = { page: 1, size: 10 };
  readonly supportedPageSizes = [10, 25, 50];
  totalCount?: number;
  isLoading?: boolean;
  searchValue = '';
  visible = false;

  ngOnInit(): void {
    this.getPageData();
  }

  reset(): void {
    this.searchValue = '';
    this.search();
  }

  search(): void {
    this.visible = false;
    this.rows = this.rows?.filter((item: any) => item.name.indexOf(this.searchValue) !== -1);
  }

  getPageData(): void {
    this.totalCount = this.rows?.length;
  }
}
